module.exports = __webpack_public_path__ + "img/实训室.bc34c6f4.png";